import { useEffect, useState } from "react";
import API from "@/lib/api";
import { ExternalLink, Info } from "lucide-react";

export const BIManagedBanner = () => {
  const [biUrl, setBiUrl] = useState(null);
  useEffect(() => { API.get("/auth/config").then(({ data }) => setBiUrl(data.bi_url)).catch(() => {}); }, []);
  return (
    <div className="flex items-center gap-2 rounded-md border border-zinc-200 bg-zinc-50 px-3 py-2 text-sm text-zinc-700"
         data-testid="bi-managed-banner">
      <Info className="w-4 h-4 text-zinc-500 shrink-0" />
      <span>Users are managed in APEX Business Intelligence.</span>
      {biUrl && (
        <a href={biUrl} target="_blank" rel="noreferrer" className="ml-auto inline-flex items-center gap-1 font-medium text-red-600"
           data-testid="bi-managed-link">Open <ExternalLink className="w-3.5 h-3.5" /></a>
      )}
    </div>
  );
};
